import { useToasterContext } from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import { GenericErrorToast } from "src/toasts"

export function useShowGenericErrorToast(id: string) {
  const { showToast } = useToasterContext()

  return useCallback(
    () => {
      showToast(
        id,
        GenericErrorToast,
      )
    },
    [
      showToast,
      id,
    ],
  )
}
